import { Chip } from '@mui/material';

export const tutorUtilizedTableHeader = (type) => [
  {
    field: 'sl_no',
    headerName: 'Sl.No',
    width: 150,
  },
  ...(type === 'cro_wise'
    ? [
        {
          field: 'cro_name',
          headerName: 'CRO Name',
          width: 200,
        },
      ]
    : []),
  {
    field: 'full_name',
    headerName: 'Tutor Name',
    width: 200,
  },
  {
    field: 'mobile_number',
    headerName: 'Phone Number',
    width: 180,
  },
  ...(type === 'subject_wise'
    ? [
        {
          field: 'trainer_assignment_status',
          headerName: 'Status',
          width: 180,
          renderCell: ({ value }) => (
            <Chip
              label={value === 1 ? 'Active' : value === 2 ? 'Temporarly Inactive' : 'Not Assigned'}
              variant="outlined"
              color={value === 1 ? 'success' : value === 2 ? 'secondary' : 'warning'}
            />
          ),
        },
      ]
    : []),
];
